import React from 'react'
import classNames from 'classnames'
import { styled } from '@mui/material/styles'
import { Box, Button } from '@mui/material'
import { Icon } from 'packages/eid-icons'

const ShowMasterWrapper = styled('div')({
    position: 'relative',
})

const LockButton = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: 0,
    bottom: '0',
    right: '0',
    left: '0',
    background: 'rgba(238, 240, 244, 0.82)',
    minHeight: '4rem',
    zIndex: '999',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
        background: 'rgba(238, 240, 244, 0.82) !important',
    },
}))

const UnlockButton = styled(Button)(({ theme }) => ({
    height: '2.4rem',
    width: '9rem',
    background: '#262fa1',
    color: 'white',
    fontSize: '1.4rem',
    borderRadius: '1rem',
    margin: 'auto',
    boxShadow: '0 0.4rem 1.6rem 0 rgba(38, 47, 161, 0.3)',
    padding: '0.2rem 0.8rem 0.2rem 0.3rem',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
        background: '#262fa1 !important',
    },
}))

const MasterLockOverlay = ({
    showMasterLock,
    handleMasterUnlock,
    children,
    btnLabel,
    styles = {},
    buttonStyles = {},
}) => {
    return (
        <ShowMasterWrapper
            className={classNames({
                showMaster: showMasterLock,
            })}
        >
            {showMasterLock && (
                <LockButton sx={{ ...styles }}>
                    <UnlockButton
                        sx={{ ...buttonStyles }}
                        onClick={() => handleMasterUnlock()}
                    >
                        <Icon
                            sx={{
                                height: '1.5rem',
                                width: '1.2rem',
                            }}
                            name={'LockRound'}
                        />
                        {btnLabel && (
                            <Box
                                component="span"
                                sx={{
                                    fontSize: '1.2rem',
                                    marginLeft: '0.4rem',
                                }}
                            >
                                {btnLabel}
                            </Box>
                        )}
                    </UnlockButton>
                </LockButton>
            )}
            {children}
        </ShowMasterWrapper>
    )
}

export default MasterLockOverlay
